import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client/core';
import { createPersistedQueryLink } from '@apollo/client/link/persisted-queries';
import { sha256 } from 'crypto-hash';
import { print } from 'graphql';

// HTTP connection to the API
const httpLink = new HttpLink({ uri: 'https://content.api.delfi.lt/content/v3/graphql' });

// const linkChain = createPersistedQueryLink({ useGETForHashedQueries: true, sha256 }).concat(httpLink);
const linkChain = createPersistedQueryLink({
  useGETForHashedQueries: true,
  generateHash: async (document) => {
    return await sha256(print(document));
  },
}).concat(httpLink);

// Cache implementation
const cache = new InMemoryCache();

// Create the apollo client
const apolloClient = new ApolloClient({
  link: linkChain,
  cache,
  defaultOptions: {
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
  },
});

export default apolloClient;
